

export class HomePageSection {
  title!: string;
  text1!: string;
  text2!: string;
  videoUrl!: string;
  /* right or left */
  fade!: string;
  classes!:string
}
